import React from 'react';

import { CmFlex, CmFormLabel, CmText } from '@/components/uiParts';

type Props = {
  label: string;
  name: string;
  width?: string;
};

export const CmLabelAndText: React.FC<Props> = ({
  label,
  name,
  width = '200px',
}) => {
  return (
    <CmFlex>
      <CmFormLabel mb="0" mr="0" {...{ width }} fontWeight="bold">
        {label}
      </CmFormLabel>
      <CmText width={`calc(100% - ${width}px)`}>{name}</CmText>
    </CmFlex>
  );
};
